import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { getSuggestionIds, type IInfiniteSearchResult } from 'shared/api/offers';

import type { IHttpApi } from '@cian/http-api/shared';

type TResult =
  | { ok: true; recommendations: IInfiniteSearchResult[] }
  | { ok: false; error: unknown; shouldRetry: boolean };

export async function getSuggestionIdsResult(
  httpApi: IHttpApi,
  parameters: Parameters<typeof getSuggestionIds>[1],
): Promise<TResult> {
  try {
    return { ok: true, recommendations: await getSuggestionIds(httpApi, parameters) };
  } catch (error) {
    const shouldRetry = !HttpBadStatusCodeError.is(error) || error.statusCode >= 500;

    return { ok: false, error, shouldRetry };
  }
}
